import { getFormatedCarName } from "./getFormatedCarName";

export const getFallbackMakeLogoImage = (carMake) => {
    try{
        const preparedCarMake = getFormatedCarName(carMake);
    const imageExtension = "png";

    //Must use context because of dynamic import of local images
    const getImage = require.context(
        '../../../../SharedComponents/assets/images/car-brand-logos',
        false,
        /\.(png)$/
    );

    const Image = getImage(`./${preparedCarMake}.${imageExtension}`);

    return Image;
    }catch(err){
        console.error(err);
    }
    
};